
<script setup>
    import { computed, reactive, onMounted, watch } from 'vue'
    import { onAuthStateChanged, signOut } from "firebase/auth";
    import { useRouter } from 'vue-router'
    import { ref as databaseRef, onValue, update, push, child, set } from "firebase/database";
    import { formatToTimeZone } from 'date-fns-timezone';
    import { useRoute } from 'vue-router'
    import HeaderComponent from "../../components/common/HeaderComponent.vue"
    import NavigationBar from "../../components/business/NavigationBar.vue"
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import PaginateComponent from 'vuejs-paginate-next'
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"
import AppSettingsView from './AppSettingsView.vue';

    const DATEFORMAT = 'YYYY/MM/DD HH:mm';
    const TIME_ZONE_TOKYO = 'Asia/Tokyo';
    const auth = Firebase.auth
    const database = Firebase.database;
    const router = useRouter()
    const route = useRoute()

    //タッチ情報情報等のリアクティブオブジェクト
    const reactiveObj = reactive({
        //企業コード
        corporateId: '',
        //登録者
        register: {},
        //タッチ情報のオブジェクト
        touchInfoObjects: [],
        //モーダルフラグ
        modalFlag: false,
        //モーダルに表示するメッセージ
        modalMessage: '',
        //モーダルに表示する追加オブジェクト
        otherObject: {},
        //再描画キー
        renderKey: 0,
        //現在のページ
        currentPage: 1,
        //削除用のインデックス番号
        deleteIndex: undefined,
        //アプリ設定情報
        appSettings: {},
        //登録日のソートフラグ
        ascending: true
    })
    //1ページに表示する件数
    const RegistrationTypeDict = {
        N: 'NFC',
        P: '暗証番号',
        F: '指紋'
    }
    const perPage = 10;

    //登録日でソートする
    const sortObjects = () => {
        //ソートフラグを参照して、true=>昇順、false=>降順で登録日をソート
        reactiveObj.touchInfoObjects.sort((element, nextElement) => {
            return reactiveObj.ascending 
                ? (element['RegistrationDate'] > nextElement['RegistrationDate'] ? -1 : 1)
                : (element['RegistrationDate'] < nextElement['RegistrationDate'] ? -1 : 1);
        });
        reactiveObj.ascending = !reactiveObj.ascending; // 次回のクリック時に逆順にする
    }
    //firebaseからタッチ情報を取得
    const getTouchInformation = async() => {
        if(reactiveObj.corporateId) {
            const touchInfoRef = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/TouchInformation`)
            //firebaseからドア情報を取得する
            onValue(touchInfoRef, (snapshot) => {
                reactiveObj.touchInfoObjects = []
                const touchInfoObjects = (snapshot.val())
                for (let key in touchInfoObjects) {
                    reactiveObj.touchInfoObjects.push({
                        'touchInfoId': key,
                        'RegistrationDate': touchInfoObjects[key]['RegistrationDate'],
                        'UserId': touchInfoObjects[key]['UserId'],
                        'RegistrationType': touchInfoObjects[key]['RegistrationType'],
                        'TerminalUUId': touchInfoObjects[key]['TerminalUUId'],
                        'MediaId': touchInfoObjects[key]['MediaId'],
                    })
                }
                //RegistrationDate順に並び替え
                sortObjects()
            })
            reactiveObj.renderKey++
        }
    }
    //表示する名称を取得
    const getName = (UserId) => {
        let Name = ''
        if(reactiveObj.appSettings.UseName1) {
            Name = `${reactiveObj.register[UserId].LastName1} ${reactiveObj.register[UserId].FirstName1}`
        }
        else if(reactiveObj.appSettings.UseName2) {
            Name = `${reactiveObj.register[UserId].LastName2} ${reactiveObj.register[UserId].FirstName2}`
        }
        return Name
    }
    //タッチ情報削除のモーダルウィンドウを開く際に実行
    const showDeleteModal = (key) => {
        reactiveObj.deleteIndex = key
        //子コンポーネントに渡すオブジェクト
        reactiveObj.otherObject = {
            confirm: '削除する',
            modalWidth: "35%",
        }
        //モーダルウィンドウを開く
        reactiveObj.modalFlag = true
        //モーダルウィンドウに表示するメッセージを設定　※ここでHTMLの設定しないと反映できない
        reactiveObj.modalMessage = `このデータを削除します。<br>よろしいですか？`
        //モーダルウィンドウを再描画
        reactiveObj.renderKey++
    }
    //タッチ情報削除のモーダルウィンドウを閉じる際に実行
    const closeDeleteModal = async (deleteFlag) => {
        //モーダルウィンドウを閉じる
        reactiveObj.modalFlag = false
        //削除に同意しているか
        if(deleteFlag) {
            // 利用者ユーザー情報のタッチ情報を削除
            const userInfoData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/User/${reactiveObj.touchInfoObjects[reactiveObj.deleteIndex]['UserId']}`);
            //登録種別によってフラグをOFFする項目を識別

            switch(reactiveObj.touchInfoObjects[reactiveObj.deleteIndex]['RegistrationType']){
                case 'N':
                    await update(userInfoData, {'NFCFlag': false, 'LatestUpdated':Date.now()});
                    break;
                case 'P':
                    await update(userInfoData, {'PINFlag': false, 'LatestUpdated':Date.now()});
                    break;
                case 'F':
                    await update(userInfoData, {'FingerFlag': false, 'LatestUpdated':Date.now()});
                    break;
                default:
                    //何もしない
                }
            const touchInfoData = databaseRef(database, `CorporateId/${reactiveObj.corporateId}/TouchInformation/${reactiveObj.touchInfoObjects[reactiveObj.deleteIndex]['touchInfoId']}`);
            await set(touchInfoData, {})
            reactiveObj.deleteIndex = undefined
            //削除後にページ数が減った場合の調整
            adjustPagecount()
        }
    }
    //ページネーションを押下した時
    const clickCallback = (pageNum) => {
        reactiveObj.currentPage = Number(pageNum);
    }
    //Nページ目に表示するドア情報を取得
    const getItems = computed(() => {
        let current = reactiveObj.currentPage * perPage;
        let start = current - perPage;
        return reactiveObj.touchInfoObjects.slice(start, current);
    })
    //現在のページ数を取得
    const getPageCount = computed(() => {
        return Math.ceil(reactiveObj.touchInfoObjects.length / perPage) ? Math.ceil(reactiveObj.touchInfoObjects.length / perPage) : 1
    })
    //削除後にページ数が減った場合の調整
    const adjustPagecount = async () => {
        //現在のページを再計算
        const maxPage = Math.ceil(reactiveObj.touchInfoObjects.length / perPage) ? Math.ceil(reactiveObj.touchInfoObjects.length / perPage) : 1
        //削除後にページ数が減った場合、現在のページ = 全体のページ数とする
        if (reactiveObj.currentPage > maxPage) {
            reactiveObj.currentPage = Number(maxPage);
            //モーダルウィンドウを再描画
            reactiveObj.renderKey++
        }
    }
    //コンポーネントがマウントされた後に実行
    onMounted(async () => {
        //企業コードの取得
        reactiveObj.corporateId = await utilFunctions.getCorporateId()
        //登録者一覧を取得
        reactiveObj.register = await utilFunctions.getRegister(reactiveObj.corporateId)
        //アプリ設定情報を取得
        reactiveObj.appSettings = await utilFunctions.getAppSetting(reactiveObj.corporateId)
        //タッチ情報一覧を取得する
        await getTouchInformation()
    })
</script>
<template>
    <!-- コメントアウト用 -->
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <div class="touchInformation" :key="`${reactiveObj.renderKey}-touchInformation`">
            <div class="titleArea">
                <p class="title">タッチ情報管理</p>
            </div>
            <div class="tableArea">
                <table class="commonTable">
                    <tbody>
                        <tr>
                            <th id="RegistrationDate" class="leftSideTh">登録日<button id="sortButton" @click="sortObjects()">▼</button>
                            </th>
                            <th id="Name" class="leftSideTh">名前</th>
                            <th id="RegistrationType">登録種別</th>
                            <th id="delete">削除</th>
                        </tr>
                        <tr v-for="(data, key) in getItems" :key="key">
                            <td class="leftSideTd">{{ formatToTimeZone(data.RegistrationDate, DATEFORMAT, { timeZone: TIME_ZONE_TOKYO }) }}</td>
                            <td class="leftSideTd">{{ getName(data.UserId) }}</td>
                            <td>{{ RegistrationTypeDict[data.RegistrationType] }}</td>
                            <td><button type="button" class="deleteButton" @click="showDeleteModal((reactiveObj.currentPage-1)*perPage+key)"><img src="../../assets/delete.png" id="deletelIcon"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <DefaultModalComponent
                :key="reactiveObj.renderKey"
                :modalMessage="reactiveObj.modalMessage"
                :otherObject="reactiveObj.otherObject"
                v-show="reactiveObj.modalFlag"
                @executeMethod="closeDeleteModal">
            </DefaultModalComponent>
        </div>
         <div class="paginationArea">
            <PaginateComponent
                :page-count="getPageCount"
                :click-handler="clickCallback"
                :page-range="5"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :force-page="reactiveObj.currentPage">
            </PaginateComponent>
        </div>
    </main>
</template>

<style scoped>
    .touchInformation{
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    .commonTable #RegistrationDate{
        width: 30%;
    }
    .commonTable #Name{
        width: 30%;
    }
    .commonTable #RegistrationType{
        width: 30%;
    }
    #thspace{
        width: 80%;
    }
    #sortButton{
        border: 3px solid #979191;
        color: #F5F5F5;
        background: transparent;
        cursor: pointer;
        font-size: 12px;
        text-align: right;
        margin: 15px;
    }
    @media (max-width: 1150px) {
        .touchInformation{
            padding: 0 5% 0 5%;
        }
        .tableArea {
            overflow-x: scroll;
        }
         #sortButton{
            border: none;
         }
    }
</style>
